import { BodyText } from "@fanduel/formation-react-components";
import Tag from "@/components/tag/Tag";
import { Maybe } from "@/graphql/gql/graphql";
import { relativeDate } from "@/utils/date";
import styles from "./articlePublishInfo.module.scss";

type ArticlePublishInfoProps = {
  sportName: string;
  sportSlug: string;
  author: string;
  date?: Maybe<string>;
};

const ArticlePublishInfo = ({
  sportName,
  sportSlug,
  author,
  date,
}: ArticlePublishInfoProps) => (
  <div className={styles.container}>
    <Tag intent="neutral" label={sportName} href={`/${sportSlug}`} />
    <div className={styles.author}>{author}</div>
    {date && (
      <BodyText size="sm" className={styles.time}>
        <time dateTime={date} suppressHydrationWarning>
          {` • ${relativeDate(date)}`}
        </time>
      </BodyText>
    )}
  </div>
);

export default ArticlePublishInfo;
